var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.clickOutsideConfig),expression:"clickOutsideConfig"}],staticClass:"kd-font-select"},[_c('div',{staticClass:"kd-font-select__head",style:({
      backgroundImage: _vm.selectedBackgroundImageCss,
    }),on:{"click":_vm.toggle}},[_c('img',{staticClass:"kd-font-select__toggle-icon",class:{
      'kd-font-select__toggle-icon--rotated': !_vm.isClosed,
    },attrs:{"src":_vm.arrowDownIcon}})]),_c('div',{staticClass:"kd-font-select__list",class:{
      'kd-font-select__list--is-closed': _vm.isClosed,
    }},_vm._l((_vm.options),function(option){return _c('div',{key:option.id,staticClass:"kd-font-select__item",style:({
        backgroundImage: ("url(" + (option.imageUrl) + ")"),
      }),on:{"click":function($event){_vm.onItemSelect(option.name)}}})}))])}
var staticRenderFns = []

export { render, staticRenderFns }